import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import { EmitterService } from '@services';

@Component({
    selector: 'msc-learn-detail-journey',
    templateUrl: './journey.component.html'
})
export class LearnDetailJourneyComponent implements OnInit {
    public hasCorrections: boolean;

    constructor(private route: ActivatedRoute, private emitterService: EmitterService) {}

    // JourneyDetailsCorrectionsResolver ya no bloquea la navegación: en vez de un array ya
    // resuelto en el snapshot, route.data.corrections trae { corrections$ } -- nos suscribimos
    // acá para reaccionar cuando llegue, en vez de leerlo síncronamente.
    ngOnInit(): void {
        this.route.data.pipe(
            switchMap((data: any) => data.corrections?.corrections$ ?? [])
        ).subscribe((corrections: any[]) => {
            this.hasCorrections = (corrections || [])
                .filter(correction => correction.corrections && correction.corrections.length)
                .reduce((accumulator, current) => [...accumulator, current.corrections], []).length > 0;
            this.emitterService.set('has-corrections', this.hasCorrections);
        });
    }
}
